<template>
  <div>
    <v-toolbar class="toolbar-element" light absolute flat height="90em">
      <v-toolbar-title class="toolbar-title">Creación Deuda entre Clubes</v-toolbar-title>
    </v-toolbar>
    <div class="loading spacing-top" v-if="loading">
      <v-flex offset-xs5 pa-5>
        <v-progress-circular :size="100" :width="5" color="primary" indeterminate></v-progress-circular>
      </v-flex>
    </div>
    <div v-else class="spacing-top">
      <v-card>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs2 pl-5>
              <v-switch label="Es transferencia?" v-model="esTransferencia"></v-switch>
            </v-flex>
            <v-flex xs10 v-if="esTransferencia">
                <v-select v-model="transferencia" label="Transferencia" :error-messages="transferenciaErrors"
                            :items="transferencias">
                  <template slot="selection" slot-scope="transferencia">
                      {{ transferencia.item | formatTransferencia }}
                  </template>
                  <template slot="item" slot-scope="transferencia">
                      {{ transferencia.item | formatTransferencia }}
                  </template>
                </v-select>
            </v-flex>
            <v-flex xs5 v-if="!esTransferencia">
                <v-autocomplete v-model="clubAcreedor" label="Club Acreedor" :error-messages="clubAcreedorErrors"
                            :items="clubes" item-text="nombre" item-value="pk"></v-autocomplete>
            </v-flex>
            <v-flex xs5 v-if="!esTransferencia">
                <v-autocomplete v-model="clubDeudor" label="Club Deudor" :error-messages="clubDeudorErrors"
                            :items="clubes" item-text="nombre" item-value="pk"></v-autocomplete>
            </v-flex>
            <v-flex v-if="!esTransferencia">
              <AttachFile ref="fileInput" @upload="uploadFiles" description single-file></AttachFile>
            </v-flex>
          </v-layout>
        <v-card-actions>
          <confirmation-dialog :function-yes="bindingFunction" ref="confirm" title="Abandonar formulario"
                    text="Se perderán los cambios del formulario actual, ¿desea continuar?"></confirmation-dialog>
          <p class="red--text mr-3" v-for="error in fileErrors" :key="error">{{ error }}</p>
          <v-btn color="grey" :disabled="saving" @click="goBackConfirmation">Volver</v-btn>
          <v-btn v-if="!esTransferencia" @click="openFileDirectory" color="primary" :disabled="saving">Agregar adjunto</v-btn>
          <v-btn @click="uploadAllFiles" color="primary" :disabled="saving">{{ (isEditing) ? 'Guardar':'Crear' }}</v-btn>
        </v-card-actions>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, requiredIf } from 'vuelidate/lib/validators'
import { createEntityMixin } from '../../../mixins/createEntityMixin'
import { s3UploadMixin } from '../../../mixins/s3UploadMixin'
import ConfirmationDialog from '../../../common/ui/ConfirmationDialog'
import AttachFile from '../../../common/ui/AttachFile'

export default {
  mixins: [validationMixin, createEntityMixin, s3UploadMixin],
  validations: {
    esTransferencia: { required },
    transferencia: {
      required: requiredIf(function () { return this.esTransferencia }) },
    clubAcreedor: {
      required: requiredIf(function () { return !this.esTransferencia }) },
    clubDeudor: {
      required: requiredIf(function () { return !this.esTransferencia }) },
    files: { required: requiredIf(function () { return !this.isEditing && !this.esTransferencia }) }
  },

  filters: {
    formatTransferencia (transferencia) {
      const nombre = transferencia.playerFirstName
      const apellido = transferencia.playerLastName
      const clubDeudor = transferencia.clubDeudor.nombre
      const clubAcreedor = transferencia.clubAcreedor.nombre
      return `Transferencia de jugador ${apellido} ${nombre} de Club ${clubAcreedor} a Club ${clubDeudor}`
    }
  },

  components: {
    AttachFile,
    ConfirmationDialog
  },

  data () {
    return {
      loading: false,
      esTransferencia: false,
      transferencia: null,
      clubDeudor: null,
      clubAcreedor: null,
      createPath: 'deuda/new',
      transferencias: [],
      clubes: []
    }
  },
  computed: {
    clubDeudorErrors () {
      let errors = this.getRequiredErrors('clubDeudor')
      if (this.$v.clubAcreedor.$dirty) {
        if (this.clubDeudor === this.clubAcreedor) {
          errors.push('El club deudor no puede ser el mismo que el club acreedor.')
        }
      }
      return errors
    },
    clubAcreedorErrors () {
      return this.getRequiredErrors('clubAcreedor')
    },
    transferenciaErrors () {
      return this.getRequiredErrors('transferencia')
    },
    fileErrors () {
      return this.getRequiredErrors('files', 'Adjunto requerido.')
    },
    isEditing () {
      return this.$route.params.hasOwnProperty('id')
    }
  },
  methods: {
    getPayload () {
      const payload = {}
      if (this.esTransferencia) {
        payload.transferencia = this.transferencia.pk
        payload.clubDeudor = this.transferencia.clubDeudor.pk
        payload.clubAcreedor = this.transferencia.clubAcreedor.pk
      } else {
        payload.clubDeudor = this.clubDeudor
        payload.clubAcreedor = this.clubAcreedor
        payload.asset = this.assets
      }
      return payload
    },
    fetchTransferencias () {
      this.axios
        .get('transferencias')
        .then(response => {
          this.transferencias = response.data
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    fetchClubes () {
      this.axios
        .get('clubes')
        .then(response => {
          this.clubes = response.data
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    isValidForm () {
      if (this.esTransferencia) {
        return !this.$v.$invalid
      }
      return !this.$v.$invalid && this.clubDeudor !== this.clubAcreedor
    }
  },
  created () {
    this.fetchClubes()
    this.fetchTransferencias()
  }
}
</script>

<style scoped>
  .spacing-top {
    margin-top: 6em !important;
  }

  .toolbar-element {
    background: linear-gradient(#e2e2e2, #cbd1db);
  }

  .toolbar-title {
    font-size: 2.2em;
    font-family: SourceSansProLight, sans-serif;
    color: #293968;
  }
</style>
